import { sendErrorNotification } from "@components/Notifications";
import { circulationStatsApi } from "@api/stats/circulationStats";

export const IS_LOADING = "statsOverdueDocuments/IS_LOADING";
export const SUCCESS = "statsOverdueDocuments/SUCCESS";
export const HAS_ERROR = "statsOverdueDocuments/HAS_ERROR";

export const fetchOverdueDocuments = (fromDate, toDate) => {
  return async (dispatch) => {
    dispatch({
      type: IS_LOADING,
    });

    try {
      const response = await circulationStatsApi.getOverdueDocuments(
        fromDate,
        toDate
      );
      await dispatch({
        type: SUCCESS,
        payload: response.data,
      });
    } catch (error) {
      await dispatch({
        type: HAS_ERROR,
        payload: error,
      });
      await dispatch(sendErrorNotification(error));
    }
  };
};
